module.exports = __webpack_public_path__ + "media/images/business/img-feature-scout-8fd81b5b9ff69a32cc509c6eb0c80f58.png";